import React, { Dispatch, useEffect, useState } from "react"
import { connect, useDispatch, useSelector } from "react-redux"
import { size, get, includes, isEmpty } from "lodash"
import { Route, RouteComponentProps } from "react-router-dom"
import { withRouter } from "react-router"

import store from "redux/store"
import {
  changeRegisterSheet,
  initRegisterLoad,
  editRegisterSymbolSheet,
  RegisterSymbolStateType,
} from "redux/ducks/RegisterSymbol"

import { FourHalfTemplate } from "components/templates/register"
import { FourTemplate } from "components/templates/register"
import { PortfolioTemplate } from "components/templates/register"
import { RegisterTemplate } from "components/templates/register"
import { SignTemplate } from "components/templates/register"
import {
  UseRegisterSymbolActionType,
  useRegisterSymbolData,
} from "components/actions/register"
import { APIResponse } from "redux/apis/types"
import { LoadStateType } from "redux/ducks/PageLoad"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"
import { setThemeFunction } from "utils/util"
import { UserStorage } from "utils/userStorage"
import { chartColorSetting } from "redux/ducks/Chart"
import chartColors from "components/atoms/chart/logic/chartColor"

type RegisterBaseType = {
  routes?: Array<{
    path: string
    name: string
    component: React.FC<RegisterPropsType>
  }>
}

export type RegisterPropsType = {
  registerSymbol: RegisterSymbolStateType
  symbolData: APIResponse.Res
  setSymbol: Dispatch<UseRegisterSymbolActionType>
  side?: string
  registerWindow?: boolean
  tableData?: Array<object>
  setTableData?: Function
}

export const Four: React.FC<RegisterPropsType> = props => {
  return <FourTemplate {...props} />
}

export const FourHalf: React.FC<RegisterPropsType> = props => {
  return <FourHalfTemplate {...props} />
}

export const Sign: React.FC<RegisterPropsType> = props => {
  return <SignTemplate {...props} />
}

export const Portfolio: React.FC<RegisterPropsType> = props => {
  return <PortfolioTemplate {...props} />
}

export const Register: React.FC<RegisterPropsType> = props => {
  return <RegisterTemplate {...props} />
}

const RegisterBase = (
  props: RegisterBaseType &
    RouteComponentProps & { registerSymbol: RegisterSymbolStateType }
) => {
  const [tableData, setTableData] = useState([{}])
  const [symbolData, setSymbol] = useRegisterSymbolData()
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )
  const dispatch = useDispatch()

  useEffect(() => {
    setThemeFunction()
    const elements = document.querySelector("html").className.split(" ")
    const ChartColors = includes(elements, "dark")
      ? UserStorage.TechChartColor.getDark()
      : UserStorage.TechChartColor.getWhite()
    dispatch(
      !isEmpty(ChartColors)
        ? chartColorSetting(ChartColors)
        : chartColorSetting(chartColors.initialize())
    )
  }, [])

  useEffect(() => {
    if (props.location.pathname === "/register") {
      const registerTag = UserStorage.registerTag.get()
      props.history.replace(
        isEmpty(registerTag) ? "/register/four" : get(registerTag, "tag")
      )
    } else {
      if (
        !includes(
          ["/symbol/four_half", "/symbol/four"],
          props.location.pathname
        )
      ) {
        UserStorage.registerTag.set({ tag: props.location.pathname })
      }
    }
    if (!size(props.registerSymbol.symbolSheetList.SheetList)) {
      store.dispatch(initRegisterLoad())
    }
  }, [props.location])

  useEffect(() => {
    if (!!props.registerSymbol.symbolSheet.SymbolList.length) {
      const symbol = props.registerSymbol.symbolSheet.SymbolList[0]
      setSymbol({
        type: "SET_SYMBOL_DETAIL",
        symbol: {
          SecurityType: get(symbol, "SecurityType"),
          Exchange: get(symbol, "Exchange"),
          Symbol: get(symbol, "Symbol"),
        },
      })
    }
  }, [props.registerSymbol.symbolSheet.SheetNo])

  useEffect(() => {
    if (isPageLoading)
      store.dispatch(
        changeRegisterSheet(props.registerSymbol.symbolSheet.SheetNo)
      )
  }, [isPageLoading])

  return (
    <div className="register">
      {/*DndProviderは上位componentで持つ*/}
      <DndProvider backend={HTML5Backend}>
        {props.routes.map((data, i) => (
          <Route
            exact
            key={i}
            path={data.path}
            render={() =>
              React.createElement(data.component, {
                registerSymbol: props.registerSymbol,
                symbolData: symbolData,
                setSymbol: setSymbol,
                tableData: tableData,
                setTableData: setTableData,
              })
            }
          />
        ))}
      </DndProvider>
    </div>
  )
}

export default withRouter<any, any>(
  connect((state: { registerSymbol: RegisterSymbolStateType }) => {
    return { registerSymbol: state.registerSymbol }
  })(RegisterBase)
)
